import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LangContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const { t, lang } = useLang();
  const navigate = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await login(email, password);
      toast.success(lang === "tr" ? "Hoş geldiniz" : "Welcome");
      const isAdmin = ["super_admin", "admin", "content_manager", "order_manager"].includes(data.role);
      navigate(isAdmin ? "/admin" : "/account");
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : (lang === "tr" ? "Giriş başarısız" : "Login failed"));
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="login-page" className="px-6 py-20 max-w-md mx-auto">
      <h1 className="font-heading text-4xl mb-2 text-center">{t("auth.login_title")}</h1>
      <p className="text-xs uppercase tracking-[0.2em] text-center text-[#C8A96A] mb-10">Uzungöl Kuyumculuk</p>
      <form onSubmit={submit} className="space-y-6">
        <div>
          <label className="block text-[10px] uppercase tracking-[0.2em] mb-2">{t("auth.email")}</label>
          <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
            className="w-full border-b border-[#0A0A0A] bg-transparent py-2 text-sm focus:outline-none focus:border-[#C8A96A]" />
        </div>
        <div>
          <label className="block text-[10px] uppercase tracking-[0.2em] mb-2">{t("auth.password")}</label>
          <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
            className="w-full border-b border-[#0A0A0A] bg-transparent py-2 text-sm focus:outline-none focus:border-[#C8A96A]" />
        </div>
        <button data-testid="login-submit" disabled={loading} className="w-full bg-[#0A0A0A] hover:bg-[#C8A96A] text-white py-4 text-xs uppercase tracking-[0.25em] transition-colors disabled:opacity-50">
          {loading ? t("common.loading") : t("auth.submit_login")}
        </button>
        <p className="text-center text-xs">
          <Link to="/forgot-password" data-testid="forgot-link" className="text-[#52525B] hover:text-[#C8A96A] underline underline-offset-4">{lang === "tr" ? "Şifremi unuttum" : "Forgot password?"}</Link>
        </p>
      </form>
      <p className="text-center text-sm text-[#52525B] mt-8">
        {t("auth.no_account")} <Link to="/register" className="text-[#C8A96A] underline underline-offset-4">{t("auth.submit_register")}</Link>
      </p>
    </div>
  );
}
